import { render, staticRenderFns } from "./directorIndex.vue?vue&type=template&id=65b9c95d&scoped=true"
import script from "./directorIndex.vue?vue&type=script&lang=js"
export * from "./directorIndex.vue?vue&type=script&lang=js"
import style0 from "./directorIndex.vue?vue&type=style&index=0&id=65b9c95d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b9c95d",
  null
  
)

export default component.exports